import ModuleItem from './ModuleItem.js';

export const PROFILE_MENU = {
    key: 1,
    icon: "accountbox",
    title: "Dashboard"
};
export const BUILDINGS_MENU = {
    key: 2,
    icon: "home",
    title: "Buildings & Customers"
};
export const CONTRACTS_MENU = {
    key: 3,
    icon: "ordersbox",
    title: "Contracts & Post Exhibits"
};
export const BASIC_SECURITY_MENU = {
    key: 4,
    icon: "key",
    title: "Basic Security"
};
export const TCM_COST_ESTIMATES_MENU = {
    key: 5,
    icon: "file",
    title: "TCM Cost Estimates"
};
export const BILLINGS_MENU = {
    key: 6,
    icon: "exportxlsx",
    title: "Billing & Adjustments"
};
export const FYCOSTS_MENU = {
    key: 7,
    icon: "money",
    title: "Fiscal Year Costs"
};
export const ADMIN_MENU = {
    key: 8,
    icon: "toolbox",
    title: "System Admin"
};
export const HELP_MENU = {
    key: 9,
    icon: "help",
    title: "Help"
};

const MenuItem = ({ data }) => {
    const arr1 = new Map(Object.entries(data.modules));
    const arr2 = Array.from(arr1, ([key, value]) => (key, value = { id: value.id, name: value.name, path: value.path, allowed: value.allowed, hasNotification: value.hasNotification }));
    const moduleItems = arr2.map((value) => (
        <div
            key={value.id}
            className={value.hasNotification ? "workflow-task-alert" : ""}
        >
            <ModuleItem prop={value} />
        </div>
    ));
    // TO-DO: Add aria-label, use [data.key.title + " Tab"] for tab name
    return <div className="tabpanel-item">{moduleItems}</div>;
}

export default MenuItem;